export default __webpack_public_path__ + "static/media/map-pin.8c41fcd3.svg";